import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { InputBox } from "../../components/CustomWidgets/InputBox";
import "react-phone-number-input/style.css";
import SelectBox from "../CustomWidgets/SelectBox";
import { Button, Input, Table, Modal } from "antd";
import "../../styles.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { UpdateRetailerDetails } from "../../API  Functions/ProfileFunctions";
import LoadingSpinner from "../Loading";
import { checkPermission } from "../../Utils/permissionHelper";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import { toast } from "react-toastify";
import { Trash2 } from "lucide-react"; // delete icon
import UpdatedProfile from "../../modals/UpdatedProfile";
import * as Yup from "yup";
import OtpInput from "react-otp-input";

import { Select } from "antd";
import { SendOTP } from "../Actions/SendOTP";
import { verifyOTP } from "../Actions/VerifyOTP";
const { Option } = Select;

const EtaSecretKeys = ({
  payload,
  onDataSubmit,
  profiledetail,
  data,
  fetchdetails,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showUpdatedProfile, setShowUpdatedProfile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const [initialState, setInitialState] = useState({});
const [isOtpSent, setIsOtpSent] = useState(false);
const [isVerified, setIsVerified] = useState(false);
const [otpValue, setOtpValue] = useState("");
const [showIncorrectOTPMessage, setShowIncorrectOTPMessage] = useState(false);
  const dispatch = useDispatch();


const validationSchema = Yup.object().shape({
  client_id: Yup.string().required(t("Client Id is required")),
  client_secret: Yup.string().required(t("Client Secret is required")),

});

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0)",
    zIndex: 999,
  },
  container: {
    width: "550px",
    padding: "20px",
    borderRadius: "30px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  title: {
    fontSize: "1.2rem",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "4px",
    marginTop: "10px",
  },
  description: {
    textAlign: "center",
    fontSize: "1rem",
    color: "#5C5C5C",
    marginBottom: "20px",
  },
  otpInput: {
    display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    marginBottom: "20px",
    marginTop: "10px",
  },
  otpInputField: {
    width: "40px",
    height: "40px",
    fontSize: "1.5rem",
    border: "1px solid #ccc",
    borderRadius: "7px",
    textAlign: "center",
    margin: "0 5px",
    outline: "none",
    color: "black",
  },
  resendText: {
    textAlign: "center",
    color: "#5C5C5C",
    fontSize: "0.875rem",
    marginBottom: "20px",
  },
  resendButton: {
    fontWeight: "bold",
    color: "#1b4597",

    cursor: "pointer",
  },
  verifyButton: {
    width: "60%",
    padding: "10px",
    backgroundColor: "#1b4497",
    color: "white",
    borderRadius: "8px",
    cursor: "pointer",
    margin: "0 auto",
    display: "block",
    marginTop: "50px",
    marginBottom: "20px",
    fontWeight: "600",
  },
};


  useEffect(() => {
    if (data) {
      const addr = data.retailer_details?.shop_address;
    

      formik.setValues({
        client_secret: data.retailer_details.client_secret || "",
        client_id: data.retailer_details.client_id || "",
        user_id: payload.user_id,
        store_id: payload.store_id,
      });
        setInitialState({
          client_secret: data.retailer_details.client_secret || "",
          client_id: data.retailer_details.client_id || "",
        });
    }
  }, [data]);

  const formik = useFormik({
    initialValues: {
      client_secret: "",
      client_id: "",
      user_id: payload.user_id,
      store_id: payload.store_id,
    },
    validationSchema,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      if (!checkPermission("/settings/profile", isGinne)) return;

      setLoading(true);
      try {
        // ✅ Convert to required structure

        const apipayload = {
          user_id,
          client_secret: values.client_secret,
          client_id: values.client_id,
         
        };

        const response = await UpdateRetailerDetails(apipayload);

        if (response?.status === "Update Successfully") {
          setShowUpdatedProfile(true);
          onDataSubmit();
          setInitialState({ 
            client_secret: values.client_secret,
            client_id: values.client_id,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleSendOTP = async () => {
  const payload = {
    mobile:data.retailer_details.mobile,
    country_code: "+20",
  };

  setLoading(true);
  const response = dispatch(SendOTP(payload));
  setLoading(false);

  response.then((result) => {
    if (
      result.payload?.result?.status == 200 &&
      result.payload?.result?.response == "OTP send to customer"
    ) {
      setIsOtpSent(true);
      toast.success("OTP sent successfully");
    } else {
      toast.error("Failed to send OTP");
    }
  });
};

const handleVerifyOTP = () => {
  const payload = {
    mobile: data.retailer_details.mobile,
    country_code: "+20",
    otp: otpValue,
  };

  const response = dispatch(verifyOTP(payload));

  response.then((result) => {
    if (result.payload?.result?.status === "OTP Verify successfully") {
      setIsVerified(true);   // ✅ Unlock the form
      setShowIncorrectOTPMessage(false);
    } else {
      setShowIncorrectOTPMessage(true);
    }
  });
};




  return (
    <>
      {loading && <LoadingSpinner />}

      {/* Note Section */}
      <div className="mx-8 mt-4 text-gray-600 italic text-sm">
        {t(
          "Note: The information below must be exactly the same as what you submitted to the ETA during registration."
        )}
      </div>
{!isVerified && (
  <div className="mx-8 mt-6">
    <h3 className="text-lg font-semibold mb-3">
      Verify your phone to view details
    </h3>

    {!isOtpSent ? (
      <button
  type="button"
  onClick={handleSendOTP}
  className="bg-primary text-white px-4 py-2 rounded-md font-semibold"
>
  Send Code
</button>
    ) : (
      <>
       <div className=" mt-4 text-base font-semibold ">
        {t(
          "Enter Code"
        )}
      </div>
        <div style={styles.otpInput}>
            
          <OtpInput
            type="number"
            inputType="numeric"
            value={otpValue}
            onChange={(otp) => {
              setOtpValue(otp.replace(/\D/g, ""));
              setShowIncorrectOTPMessage(false);
            }}
            numInputs={4}
            placeholder="    "
            separator={<span>-</span>}
            renderInput={(props) => <input {...props} />}
            isInputSecure={true}
            inputStyle={{
              ...styles.otpInputField,
              color: "black",
              fontSize: "medium",
            }}
            className={`${showIncorrectOTPMessage ? "border-red" : ""}`}
          />
        </div>

        {showIncorrectOTPMessage && (
          <p style={{ color: "red" }}>Incorrect OTP</p>
        )}
<button
  type="button"
  onClick={handleVerifyOTP}
  className="bg-primary text-white px-4 py-2 rounded-md font-semibold mt-3"
>
  Verify Code
</button>
      </>
    )}
  </div>
)}
{isVerified && (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setConfirmVisible(true);

          // formik.submitForm().then(() => {
          //     if (Object.keys(formik.errors).length === 0) {
          //     }
          // });
        }}
      >
        <div className="font-normal text-[#5c5c5c] mx-8 ">
          <div className="grid grid-cols-2 gap-3 my-4">
            <InputBox
              name="client_id"
              isRequird
              label={t("Client Id")}
              placeholder={t("Enter client id")}
              // maxLength={9}
              value={formik.values.client_id}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("client_id", true)}
              error={formik.errors.client_id}
              touched={formik.errors.client_id}
            />
               <InputBox
              name="client_secret"
              isRequird
              label={t("Client Secret")}
              placeholder={t("Enter Client Secret")}
              // maxLength={4}
              value={formik.values.client_secret}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("client_secret", true)}
              error={formik.errors.client_secret}
              touched={formik.errors.client_secret}
            />
          </div>

        </div>

        <div className="flex gap-5 mx-11 mt-8 mb-10 ">
          <button
            type="submit"
            // disabled={!isChanged}
            className={`w-[180px] h-[45px] rounded-lg font-semibold bg-primaryBlue text-white
            
            `}
          >
            {t("Update & Save")}
          </button>
        </div>
      </form>
)}
      {/* Confirmation Modal */}
      <Modal
        title={t("Confirm Update")}
        open={confirmVisible}
        onCancel={() => setConfirmVisible(false)}
        onOk={() => {
          setConfirmVisible(false);
          formik.handleSubmit();
        }}
        okText={t("Confirm")}
        cancelText={t("Cancel")}
        okButtonProps={{
          className:
            "bg-primaryBlue hover:bg-primaryBlue text-white border-none",
        }}
      >
        <p>{t("Please check all the details carefully before proceeding.")}</p>
      </Modal>

      {showUpdatedProfile && (
        <UpdatedProfile
          onClose={() => {
            setShowUpdatedProfile(false);
            fetchdetails();
          }}
          message={t("ETA Setup Details Updated")}
        />
      )}
    </>
  );
};

export default EtaSecretKeys;
